import ServiceManager from "./ServiceManager";
export default function service(id) {
  var options = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  return function (target) {
    ServiceManager.register(id, target, options);
  };
}